// https://www.youtube.com/watch?v=WbV3zRgpw_E&t=6960s
import React, { useState }  from 'react'
import Title from '../_title/Title'
// import Projects1 from './Projects1'
import Pasco1 from './Pasco1'




const PascoScreen = () => {
  return (
    <div>
      <div className="container">
        <Title title=" "/>
        <Pasco1/>  
      </div>
    </div>

  )
}

export default PascoScreen